import { render, staticRenderFns } from "./Activate.vue?vue&type=template&id=535835a7&scoped=true"
import script from "./Activate.vue?vue&type=script&lang=js"
export * from "./Activate.vue?vue&type=script&lang=js"
import style0 from "./Activate.vue?vue&type=style&index=0&id=535835a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535835a7",
  null
  
)

export default component.exports